import {
  array,
  boolean,
  date,
  type InferOutput,
  minLength,
  object,
  pipe,
  transform,
  union
} from 'valibot'

import { VALIDATION_MESSAGES } from '@/constants/common/validation.constants'
import { type Nullable } from '@/libs/utils'
import { nonNullableDateToStringSchema } from '@/libs/valibot'

export const duplicateDispatchDetailFormValueSchema = union([
  object({
    /** 配送日 */
    shippingDate: nonNullableDateToStringSchema,
    /** 定期複製する*/
    makeGroup: boolean()
  }),
  object({
    /** 配送日 */
    shippingDates: pipe(
      array(date()),
      transform((x) => x.map((x) => x.toISOString())),
      minLength(1, VALIDATION_MESSAGES.REQUIRED_ITEM)
    ),
    /** 定期複製する*/
    makeGroup: boolean()
  })
])

/**
 * 配車データ詳細（dispatchDetail）複製フォームの値
 */
export type DuplicateDispatchDetailFormValue = Nullable<
  InferOutput<typeof duplicateDispatchDetailFormValueSchema>
>

/**
 * 配車データ詳細（dispatchDetail）複製フォームの初期値
 */
export const duplicateDispatchDetailFormInitialValue: DuplicateDispatchDetailFormValue =
  {
    shippingDate: null,
    shippingDates: null,
    makeGroup: false
  }
